export const CORRESPONDANCE_TYPES = {
    EMAIL: "Email",
    FAX: "Fax",
    SMS: "Sms",
    SSP:"Self Service Portal",

}